import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@autobind
export default class HeaderCarbonCalculator extends Component {
    static propTypes = {
        handleAction: PropTypes.func,
        descriptionText: PropTypes.string,
        textAlign: PropTypes.oneOf(['AR', 'BR']),
        title: PropTypes.string,
        firstParagraph: PropTypes.string,
        secondParagraph: PropTypes.string,
        disclaimer: PropTypes.string,
    };

    render() {
        return (
            <div>
                <div className={this.props.textAlign === 'AR' ? styles.headAr : styles.headBr}>
                    <Title theme={settings.app.theme} size='xl' bolder className={styles.desktopTitle}>
                        {this.props.title}
                    </Title>

                    <Title color='dark' size='md'>
                        {this.props.firstParagraph}
                    </Title>
                    <Title color='dark' size='md'>
                        {this.props.secondParagraph}
                        <a className={styles.href} href='/library' target='_blank' rel='noreferrer'>
                            {_('biblioteca')}
                        </a>
                    </Title>
                    {this.props.disclaimer && (
                        <div className={styles.containerDisclaimer}>
                            <Title className={styles.disclaimer}>{this.props.disclaimer}</Title>
                        </div>
                    )}
                </div>
                <div className={this.props.textAlign === 'AR' ? styles.ARtext : styles.BRtext}>
                    <Title color='dark' size='md'>
                        {this.props.descriptionText}
                    </Title>
                </div>
            </div>
        );
    }
}
